import { Navigate, useLocation } from 'react-router-dom';

/**
 * Sends a retired path to its current one, query and hash intact, so old
 * bookmarks and links (`/home/appointments-v2`, `/home/tickets`) keep landing
 * on the right page. A query on `to` — a tab marker, say — is merged in, and
 * the incoming query wins on a clash.
 */
export default function LegacyPathRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();

  const [path, targetQuery = ''] = to.split('?');
  const params = new URLSearchParams(targetQuery);
  new URLSearchParams(search).forEach((value, key) => params.set(key, value));

  const query = params.toString();
  return <Navigate to={`${path}${query ? `?${query}` : ''}${hash}`} replace />;
}
